/* eslint-disable */
import { CommonGet, CommonPost } from '../../../helpers/HttpClient';
import TokenDecoder from 'src/helpers/TokenDecoder';


export default {
    GetProductCategoties,
    GetSpecialProductCategoryDetailsBySpecialProductCategoryID,
    SaveProductCategory,
    UpdateProductCategory
};

async function GetProductCategoties() {
    const response = await CommonGet('/api/SpecialProductCategory/GetSpecialProductCategory', null);
    return response.data;
}

async function GetSpecialProductCategoryDetailsBySpecialProductCategoryID(ProductCategoryID) {
    const response = await CommonGet('/api/SpecialProductCategory/GetSpecialProductCategoryDetailsBySpecialProductCategoryID', 'productCategoryID=' + ProductCategoryID);
    return response.data;
}

async function SaveProductCategory(values) {
    var formdata = {
        ProductCategoryName: values.productCategoryName,
        CategoryCode: values.categoryCode,
        Description: values.description,
        IsActive: values.isActive,
        CreatedBy: parseInt(TokenDecoder.getUserIDFromToken()),
        CreatedDate: new Date(),
    }
    const response = await CommonPost('/api/SpecialProductCategory/SaveSpecialProductCategory', null, formdata);
    return response;
}

async function UpdateProductCategory(values, productCategoryID) {

    var formdata = {
        ProductCategoryID: parseInt(productCategoryID),
        ProductCategoryName: values.productCategoryName,
        CategoryCode: values.categoryCode,
        Description: values.description,
        IsActive: values.isActive,
        ModifiedBy: parseInt(TokenDecoder.getUserIDFromToken()),
        ModifiedDate: new Date(),
    }
    const response = await CommonPost('/api/SpecialProductCategory/UpdateSpecialProductCategory', null, formdata);
    return response;
}